import createCache from '@emotion/cache';
const defaultMantineEmotionCache = createCache({
  key: "mantine",
  prepend: true
});
export { defaultMantineEmotionCache };